import encrypt from '../helpers/encrypt'

const TOKEN_EXPIRE = '$2a$14$wqiHQZlohDyaojXnJUVKw..6Sa73pgIBWaypXs7eh/uFo3/TySR42'
class ExpireDate {

  set (item) {
    const encryptToken = encrypt.encodeDate(item)
    return localStorage.setItem(TOKEN_EXPIRE, encryptToken)
  }

  get () {
    return localStorage.getItem(TOKEN_EXPIRE) !== null ? encrypt.decodeDate(localStorage.getItem(TOKEN_EXPIRE)) : null
  }

  remove () {
    return localStorage.removeItem(TOKEN_EXPIRE)
  }
   
}
export default new ExpireDate()